<script setup lang="ts">
import { onMounted, onUnmounted, toRefs,watch,reactive, ref, nextTick, computed } from "vue";
import CustomInfiniteLoading from './CustomInfiniteLoading.vue';
import SearchBox from './SearchBox.vue';
import qs from 'qs';
import axios from '../plugins/axios.ts';
import { deepCopy } from "../plugins/utility";
import axios_org from 'axios'

let cancel = null;
// 検索条件が変わってreset()された後に、古い条件でのリクエストが後から返ってきて上書きしてしまうのを防ぐための世代カウンタ
let requestGeneration = 0;

const props = defineProps({
    apiUrl: {
      type: String,
      default: () => {
        return '';
      }
    },
    apiMethod: {
      type: String,
      default: () => {
        return 'GET';
      }
    },
    tableFields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isTableHeaderVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    optionFields: {
      type: Object,
      default: () => {
        return null;
      }
    },
    defaultValues: {
      type: Array,
      default: () => {
        return [];
      }
    },
    width: {
      type:String,
      default: () => {
        return '13rem';
      }
    },
    height: {
      type:String,
      default: () => {
        return '';
      }
    },
    top: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    isSearchable : {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isCustomDesign : {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isOverflowY : {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isDownloadable : {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isOverflowX : {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isAllCheck : {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isTableLayoutFixed : {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isCheckable : {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    excludeCheckIds : {
      type: Array,
      default: () => {
        return [];
      }
    },
    isCellJoin : {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    placeHolder : {
      type:String,
      default: () => {
        return '';
      },
    },
    itemIndex : {
      type:Number,
      default: () => {
        return 0;
      }
    },
    listKey : {
      type:String,
      default: () => {
        return 'id';
      }
    },
    zIndex : {
      type:Number,
      default: () => {
        return null;
      }
    },
    fontSize : {
      type:String,
      default: () => {
        return '';
      }
    },
    fontLineHeight : {
      type:String,
      default: () => {
        return '';
      }
    },
    backGroundColor : {
      type:String,
      default: () => {
        return '#fff';
      }
    },
    checkValues : {
      type:[Array,Number,String],
      default: () => {
        return [];
      }
    },
    handler: {
      type:Function,
    },
    onClick: {
      type:Function,
    },
    onCheckChange: {
      type:Function,
    },
    reset: {
      type:Function,
    },
    domComplete: {
      type:Function,
    },
    responseComplete: {
      type:Function,
    }
});
const { itemIndex,checkValues } = toRefs(props);
const tableRef = ref();
const listRef = ref();
const searchWord = ref('');
const infinitId = ref(0);
const executionId = ref(0);
const items = reactive([]);
const customItems = reactive([]);
const itemAllCount = ref(0);
const isAllLoading = ref(false);
const isReadWrite = ref(false);
const offset = ref(0);
const sortParms = reactive({});
const checkList = reactive([]);
for (let i=0;i<props.checkValues.length;i++) {
  checkList.push(props.checkValues[i]);
}
const afterHandler = ref(false);
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  reset();
}
const fileDownload = () => {
  let params = createApiGetParams(true);
  params['is_download'] = 1;
  //全てのデータを取得するのでページサイズを0にする
  params['page_size'] = 0;
  params['offset'] = 0;
  const queryParameter = qs.stringify(params,{ arrayFormat: 'repeat'});
  window.open(props.apiUrl + '?' + queryParameter,'_blank');
}
const initialDefaultValues = () => {
  items.splice(0);
  for (let i=0;i<props.defaultValues.length;i++) {
    items.push(props.defaultValues[i]);
  }
}
const reset = (force=false) => {
  requestGeneration++;
  if (cancel) {
    cancel();
    cancel = null;
  }
  offset.value = 0;
  initialDefaultValues();
  if (typeof props.reset !== "undefined") {
    props.reset();
  }
  if (force == false) {
    infinitId.value++;
  } else {
    executionId.value++;
  }
}
const allCheckExec = () => {
  for (let i=0;i<items.length;i++) {
    if (props.excludeCheckIds.indexOf(items[i][props.listKey]) != -1) {
      continue;
    }
    if (checkList.indexOf(items[i][props.listKey]) == -1) {
      checkList.push(items[i][props.listKey]);
    }
  }
}
const allCheck = (event) => {
  if (event.target.checked == false) {
    checkList.splice(0);
    if (typeof props.onCheckChange !== 'undefined') {
      props.onCheckChange(deepCopy(checkList));
    }
  } else {
    if (items.length >= itemAllCount.value) {
        allCheckExec();
        if (typeof props.onCheckChange !== 'undefined') {
          props.onCheckChange(deepCopy(checkList));
        }
    } else {
      isAllLoading.value = true;
      executionId.value++;
    }
  }
}
const createApiGetParams = (allCheck = false) => {
  let params = {
    offset:offset.value,
  };
  for (let sortKey in sortParms) {
    if (sortParms[sortKey]) {
      params[sortKey] = sortParms[sortKey];
    }
  }
  if (props.optionFields !== null) {
    for (let option in props.optionFields) {
      params[option] = props.optionFields[option];
    }
  }
  if (params.hasOwnProperty('search_word') == false) {
    params['search_word'] = searchWord.value;
  }
  if (allCheck) {
    //オールチェックの場合は一括で全てのレコードを取得する
    params['full_page_size'] = itemAllCount.value + 50;
  }
  if (isReadWrite.value) {
    params['is_read_write'] = 1;
  }
  return params;
}
const load = async ($state) => {
  if (props.apiUrl.length == 0) {
    if (isAllLoading.value) {
      allCheckExec();
      isAllLoading.value = false;
    }
    $state.loaded();
    isAllLoading.value = false;
    return;
  }
  const myGeneration = requestGeneration;
  try {
    let response = null;
    if (props.apiMethod == 'GET') {
      let params = createApiGetParams(isAllLoading.value);
      const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
      response = await axios.get(props.apiUrl,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancel = c;
      })});
    } else {
      let paramBody = props.optionFields;
      paramBody['offset'] = offset.value;
      paramBody['sort_condition'] = {}
      for (let sortKey in sortParms) {
        if (sortParms[sortKey]) {
          paramBody['sort_condition'][sortKey] = sortParms[sortKey];
        }
      }
      if (props.optionFields !== null) {
        for (let option in props.optionFields) {
          if (option == 'page_size') {
            paramBody[option] = props.optionFields[option];
          }
        }
      }

      response = await axios(props.apiUrl,{method:"post",data:paramBody,cancelToken:  new axios_org.CancelToken((c) => {
        cancel = c;
      })});
    }
    if (myGeneration !== requestGeneration) {
      //この間にreset()された(検索条件が変わった)ので、古いレスポンスは反映しない
      return;
    }
    itemAllCount.value = response.data.count;
    if (response.data.list.length > 0) {
      //デフォルトにあるものは対象外にする
      let list = [];
      for (let i=0;i<response.data.list.length;i++) {
        let exists = false;
        for (let j=0;j<props.defaultValues.length;j++) {
          if (response.data.list[i][props.listKey] == props.defaultValues[j][props.listKey]) {
            exists = true;
            break;
          }
        }
        if (exists == false) {
          list.push(response.data.list[i]);
        }
      }
      if (props.top) {
        items.unshift(...response.data.list.reverse());
      } else {
        items.push(...response.data.list);
      }
    }
    if (typeof props.responseComplete !== 'undefined') {
      props.responseComplete(response.data)
    }
    if (response.data.list.length < response.data.page_size) $state.complete()
    else $state.loaded()
    await nextTick(() => {
      if (isAllLoading.value) {
        isAllLoading.value = false;
        //全てにチェックボックスを付ける
        allCheckExec();
        if (typeof props.onCheckChange !== 'undefined') {
          props.onCheckChange(deepCopy(checkList));
        }
      }
      if (afterHandler.value) {
        if (typeof props.handler !== 'undefined') {
          if (items.length > props.itemIndex) {
            props.handler('item',items[props.itemIndex],(props.itemIndex >= items.length ? true : false));
          }
        }
      }
      afterHandler.value = false;
      if (typeof props.domComplete !== 'undefined') {
        props.domComplete();
      }
      if (offset.value == 0 && props.top) {
        //一番下までスクロール
        gotoStart(true);
      }
    });
    offset.value += response.data.list.length;
  } catch (error) {
    $state.error()
    isAllLoading.value = false;
  } finally {
    cancel = null;
    isReadWrite.value = false;
  }
}
const isScrolled = ref(false);
const handleScroll = () => {
  const SCROLL_JUDGE_SIZE = 300;
  let target = getTargetElement();
  if (target != null) {
    if (props.top == false) {
      if (target.scrollTop > SCROLL_JUDGE_SIZE) { // 100px以上スクロールしたら表示
        isScrolled.value = true;
      } else {
        isScrolled.value = false;
      }
    } else {
      if ((target.scrollHeight - target.scrollTop) > (target.clientHeight + SCROLL_JUDGE_SIZE)) { // 100px以上スクロールしたら表示
        isScrolled.value = true;
      } else {
        isScrolled.value = false;
      }
    }
  }
};

const getTargetElement = () => {
  let target = null;
  if (typeof listRef.value !== 'undefined' && listRef.value != null) {
    target = listRef.value;
  } else if (typeof tableRef.value !== 'undefined' && tableRef.value != null) {
    target = tableRef.value;
  }
  return target;
}
const scrollEventRegister = () => {
  let target = getTargetElement();
  if (target != null) {
    target.addEventListener('scroll', handleScroll);
  }
}
const scrollEventUnRegister = () => {
  let target = getTargetElement();
  if (target != null) {
    target.removeEventListener('scroll', handleScroll);
  }
}
const gotoStart = (isDelay) => {
  //一番下までスクロール
  let target = getTargetElement();
  if (target != null) {
    if (isDelay) {
      setTimeout(() => {
        if (props.top) {
          target.scrollTop = target.scrollHeight;
        } else {
          target.scrollTop = 0;
        }
      },200);
    } else {
      if (props.top) {
        target.scrollTop = target.scrollHeight;
      } else {
        target.scrollTop = 0;
      }
    }
  }
}

const sortField = (field,direction) => {
  sortParms['sort_asc'] = '';
  sortParms['sort_desc'] = '';
  sortParms['sort_' + direction] = field;
  reset();
}
watch(itemIndex,(newValue, oldValue) => {
  if (typeof props.handler !== 'undefined') {
    if (items.length <= props.itemIndex) {
      //追加ロード
      afterHandler.value = true;
      executionId.value++;
    } else {
      props.handler('item',items[props.itemIndex],(props.itemIndex >= items.length ? true : false));
    }
  }
});
watch(checkValues,(newValue,oldValue) => {
  checkList.splice(0);
  for (let i=0;i<newValue.length;i++) {
    checkList.push(newValue[i]);
  }
},{deep:true})

const onItemCheckChange = (event) => {
  if (event.target.checked == true) {
    checkList.push((isNaN(event.target.value) === true ? event.target.value : Number(event.target.value)));
  } else {
    for (let i=0;i<checkList.length;i++) {
      if (checkList[i] == event.target.value) {
        checkList.splice(i,1);
        break;
      }
    }
  }
  if (typeof props.onCheckChange !== 'undefined') {
    props.onCheckChange(deepCopy(checkList));
  }
}

onMounted(() => {
  initialDefaultValues();
  scrollEventRegister();
});
onUnmounted(() => {
  scrollEventUnRegister();
})

const onItemClick = (item) => {
  if (typeof props.onClick !== 'undefined') {
    props.onClick(item);
  }
}
const allCheckValue = computed(() => {
  return (items.length > 0 && (props.checkValues.length == items.length) ? true : false);
});
const listItems = computed(() => {
  let result = [];
  for (let i=0;i<customItems.length;i++) {
    result.push(customItems[i]);
  }
  for (let i=0;i<items.length;i++) {
    result.push(items[i]);
  }
  return result;
});
const updateItem = (value):void => {
  for (let i=0;i<items.length;i++) {
    if (items[i][props.listKey] == value[props.listKey]) {
      items[i] = value;
      break;
    }
  }
}
const getItemAllCount = ():Number => {
  return itemAllCount.value;
}
const getItem = (index):Object => {
  if (index < 0 || index > (items.length+1)) {
    return null;
  }
  return items[index];
}
const getItems = ():Number => {
  return items;
}
const getItemById = (id,key='id'):Object => {
  let result = null;
  for (let i=0;i<items.length;i++) {
    if (items[i][key] == id) {
      result = items[i];
      break;
    }
  }
  return result;
}

const updateItems = (values):void => {
  for (let i=0;i<values.length;i++) {
    for (let j=0;j<items.length;j++) {
      if (items[j][props.listKey] == values[i][props.listKey]) {
        items[j] = values[i];
        break;
      }
    }
  }
}
const deleteItem = (value):void => {
  for (let i=0;i<items.length;i++) {
    if (items[i][props.listKey] == value[props.listKey]) {
      items.splice(i,1);
      offset.value--;
      break;
    }
  }
}
const addItem = (value):void => {
  items.push(value);
  offset.value++;
}
const resetItem = (delay=0):void => {
  if (delay > 0) {
    isReadWrite.value = true;
  } else {
  }
  reset();
}
const resetForceItem = (delay=0):void => {
  if (delay > 0) {
    isReadWrite.value = true;
  } else {
  }
  reset(true);
}
const clearSearch = ():void => {
  searchWord.value = '';
}
const getItemAllLoad = ():void => {
  isAllLoading.value = true;
  if (typeof props.reset !== "undefined") {
    props.reset();
  }
  executionId.value++;
}
const existsCustomItem = (id):void => {
  let result = false;
  for (let i=0;i<customItems.length;i++) {
    if (customItems[i][props.listKey] == id) {
      result= true;
      break;
    }
  }
  return result;
}
const addCustomItems = (items):void => {
  for (let i=0;i<items.length;i++) {
    customItems.push(items[i]);
  }
}
const deleteCustomItems = (id):void => {
  for (let i=0;i<customItems.length;i++) {
    if (customItems[i].id == id) {
      customItems.splice(i,1);
      break;
    }
  }
}
const clearCustomItems = ():void => {
  customItems.splice(0);
}
const getSortKey = ():String => {
  return sortParms['sort_asc'] ? sortParms['sort_asc'] : sortParms['sort_desc'];
}
const getSortDirection = ():String => {
  return sortParms['sort_desc'] ? 'desc' : 'asc';
}
defineExpose({
  updateItem,
  updateItems,
  getItemAllCount,
  deleteItem,
  addItem,
  getItem,
  getItems,
  getItemById,
  resetItem,
  resetForceItem,
  clearSearch,
  getItemAllLoad,
  addCustomItems,
  deleteCustomItems,
  clearCustomItems,
  existsCustomItem,
  getSortKey,
});

</script>

<style scoped>
ul {
  padding: 2px;
  position: relative;
}

li.design {
  color: #323233;
  background: #fff5e0;
  margin-bottom: 3px;
  line-height: 1.5;
  padding: 0.5em;
  list-style-type: none!important;
  font-size: 0.75rem;
  cursor: pointer;
}
table {
  width:100%;
  border-collapse:collapse;
}
table > thead > tr > th {
  border-bottom: 2px solid #ccc;
  border-right: 1px solid #fff;
  position:sticky;
  top:0;
  left:0;
  z-index:1;
  background-color: rgb(97, 97, 97);
  color:#fff;
  line-height: 1.4;
}
table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table > tbody > tr > td {
  padding:0.5em;
  white-space: pre-wrap;
}
.loading-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-flow: column;
  transition: opacity 0.3s ease;
}
.loading-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.goto {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 2.8rem;
  bottom: 0.5rem;
  cursor: pointer;
  border: 0;
  background: none;
  transition: .2s;
  letter-spacing: 3px;
  opacity: 1;
  visibility: visible;
}

.goto span.top:before {
    position: absolute;
    top: -29px;
    left: 16px;
    transform: rotate(-45deg);
    display: block;
    width: 12px;
    height: 12px;
    content: "";
    border: 1px solid #767575;
    border-width: 1px 1px 0px 0px;
}
.goto span.bottom:before {
    position: absolute;
    top: -35px;
    left: 16px;
    transform: rotate(135deg);
    display: block;
    width: 12px;
    height: 12px;
    content: "";
    border: 1px solid #767575;
    border-width: 1px 1px 0px 0px;
}

.goto span:after {
    position: absolute;
    width: 32px;
    height: 32px;
    border: 1px solid #767575;
    content: "";
    border-radius: 100%;
    top: -43px;
    left: 5px;
}
</style>
<template>
<div class="w-full text-xs md:text-base" :style="(zIndex != null ? 'position:relative;z-index:' + zIndex + ';' : '') + (fontSize.length > 0 ? 'font-size:' + fontSize + ';' : '') + (fontLineHeight.length > 0 ? 'line-height:' + fontLineHeight + ';' : '')">
  <div v-show="isAllLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../public/images/loading.gif"></span>
    </div>
  </div>
  <div v-show="isSearchable" class="mb-4 mt-1 flex w-full" :style="'width:' + width">
    <search-box
      :search-word="searchWord"
      :on-change="onSearchWordChange"
      :on-enter="onSearchWordEnter"
      :place-holder="placeHolder"
    ></search-box>
  </div>
  <div v-show="isDownloadable">
    <button class="m-1 text-base bg-amber-500 hover:bg-amber-700 text-white font-bold py-1 px-2 border border-amber-500 rounded" @click="fileDownload"><i class="fa-solid fa-cloud-arrow-down"></i> csv</button>
  </div>
  <div ref="tableRef" v-if="tableFields.length > 0" :class="'overscroll-none' + (isOverflowY ? ' overflow-y-auto ' : ' overflow-y-hidden ') + (isOverflowX ? ' overflow-x-auto ' : ' overflow-x-hidden ') + 'mt-1  bg-white'" :style="(height.length > 0 ? 'height:' + height : 'auto')">
    <table :class="(isTableLayoutFixed ? 'table-fixed' : '')">
      <thead v-show="isTableHeaderVisible" class="min-h-12">
        <tr>
          <th v-show="isCheckable" style="width:3%;"><input v-show="isAllCheck" type="checkbox" @change="allCheck($event)" :checked="allCheckValue" class="text-center"></th>
          <th v-for="(field,index) in tableFields" :style="'width:' + field.width" :class="'whitespace-nowrap md:whitespace-initial	' + 'text-center ' + field.field_key + '_help'">
            <span v-html="field.field_name"></span>
            <span @click="sortField(field.field_key,'desc')" v-show="typeof field.sorted !== 'undefined' && field.sorted" class="cursor-pointer ml-1 text-xs text-white rounded border border-white px-1"><i class="fa-solid fa-caret-up"></i></span>
            <span @click="sortField(field.field_key,'asc')" v-show="typeof field.sorted !== 'undefined' && field.sorted" class="cursor-pointer mr-1 text-xs text-white rounded border border-white px-1"><i class="fa-solid fa-caret-down"></i></span>
          </th>
        </tr>
      </thead>
      <tbody class="overflow-x-scroll md:overflow-x-auto whitespace-nowrap md:whitespace-initial">
        <tr v-if="isCellJoin == false && top == false" :class="(!isCustomDesign ? 'design' : '')" v-for="(item,index) in listItems" :key="item[props.listKey]">
          <td v-show="isCheckable && excludeCheckIds.indexOf(item[props.listKey]) == -1"><input type="checkbox" v-model="checkList" @change="onItemCheckChange" :value="item[props.listKey]"></td>
          <slot name="item" v-bind:item="item" v-bind:index="index"></slot>
        </tr>
        <slot v-else-if="isCellJoin == true && top == false" v-for="(item,index) in listItems" :key="item[props.listKey]" name="item" v-bind:item="item" v-bind:index="index"></slot>
        <CustomInfiniteLoading @infinite="load" :top="top" :distance="5" :execution="executionId" :identifier="infinitId" list-type="table">
        <template #spinner>
          <td :colspan="tableFields.length">
            <img class="mx-auto" src="../../public/images/loading.gif">
          </td>
        </template>
        <template #complete>
          <td :colspan="tableFields.length + (isCheckable ? 1 : 0)" class="text-center">
            <div><span class="mt-1 p-2 text-sm text-left text-gray-500">これ以上ありません。</span></div>
            <div><a href="javascript:void(0)" class="w-full my-1 flex justify-center cursor-pointer" @click="reset(false)"><i class="fa-solid fa-rotate-right"></i></a></div>
          </td>
        </template>
        <template #error="{ retry }">
          <td :colspan="tableFields.length + (isCheckable ? 1 : 0)" class="p-4 text-center">
            <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 border border-green-500 rounded" @click="retry">再試行</button>
          </td>
        </template>
        </CustomInfiniteLoading>
        <tr v-if="isCellJoin == false && top == true" :class="(!isCustomDesign ? 'design' : '')" v-for="(item,index) in listItems" :key="item[props.listKey]">
          <td v-show="isCheckable && excludeCheckIds.indexOf(item[props.listKey]) == -1" style="width:3%;"><input type="checkbox" v-model="checkList" @change="onItemCheckChange" :value="item[props.listKey]"></td>
          <slot name="item" v-bind:item="item" v-bind:index="index"></slot>
        </tr>
        <slot v-else-if="isCellJoin == true && top == true" v-for="(item,index) in listItems" :key="item[props.listKey]" name="item" v-bind:item="item" v-bind:index="index"></slot>
      </tbody>
    </table>
  </div>
  <div v-else ref="listRef" :class="(isOverflowY ? ' overflow-y-auto ' : ' overflow-y-hidden ') + (isOverflowX ? ' overflow-x-auto ' : ' overflow-x-hidden ') + ' border border-solid border-gray-200'" :style="'background-color:' + backGroundColor + ';width:' + width + ';height:' + (height.length == 0 ? '15rem' : height)">
    <div v-show="isCheckable && isAllCheck"><input v-show="isAllCheck" type="checkbox" @change="allCheck($event)" :checked="allCheckValue">全て</div>
    <ul>
      <li v-show="top == false" @click="onItemClick(item)" :class="(!isCustomDesign ? 'design flex flex-row items-center' : '')" v-for="(item,index) in listItems" :key="item[props.listKey]" :style="(fontSize.length > 0 ? 'font-size:' + fontSize + ';' : '') + (fontLineHeight.length > 0 ? 'line-height:' + fontLineHeight + ';' : '')">
        <input v-show="isCheckable && excludeCheckIds.indexOf(item[props.listKey]) == -1" type="checkbox" v-model="checkList" @change="onItemCheckChange" :value="item[props.listKey]" class="mr-2">
        <slot name="item" v-bind:item="item" v-bind:index="index"></slot>
      </li>
      <CustomInfiniteLoading @infinite="load" :top="top" :distance="5" :execution="executionId" :identifier="infinitId">
      <template #spinner>
        <div class="w-full flex justify-center">
          <div style="color: white;"><img src="../../public/images/loading.gif"></div>
        </div>
      </template>
      <template #complete>
        <div><span class="mt-1 p-2 text-sm text-left text-gray-500">これ以上ありません。</span></div>
        <div><a href="javascript:void(0)" class="w-full my-1 flex justify-center cursor-pointer" @click="reset(false)"><i class="fa-solid fa-rotate-right"></i></a></div>
      </template>
      <template #error="{ retry }">
        <div class="p-4">
          <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 border border-green-500 rounded" @click="retry">再試行</button>
        </div>
      </template>
      </CustomInfiniteLoading>
      <li v-show="top == true" @click="onItemClick(item)" :class="(!isCustomDesign ? 'design flex flex-row items-center' : '')" v-for="(item,index) in listItems" :key="item[props.listKey]" :style="(fontSize.length > 0 ? 'font-size:' + fontSize + ';' : '') + (fontLineHeight.length > 0 ? 'line-height:' + fontLineHeight + ';' : '')">
        <input v-show="isCheckable && excludeCheckIds.indexOf(item[props.listKey]) == -1" type="checkbox" v-model="checkList" @change="onItemCheckChange" :value="item[props.listKey]" class="mr-2">
        <slot name="item" v-bind:item="item" v-bind:index="index"></slot>
      </li>
    </ul>
  </div>
  <div v-if="isScrolled" class="goto"><span @click="gotoStart(false)" :class="top ? 'bottom' : 'top'"></span></div>
</div>
</template>

